import { Box } from '@mui/material';
import React from 'react';
import { AutocompleteInput as VeroAutocompleteInput } from './wrappers/Inputs';
import { AutocompleteInput as RAAutocompleteInput } from 'react-admin';
import { useAzureADGroups } from '../msal/useAzureADGroups';

const validateVersioningType = (value, allValues, resource) => {
    if ((resource === 'Course' || resource === 'Module' ) && allValues.id && !value) {
        return 'Version type is required';
    }
    return undefined;
};

export const VersioningTypeInput = ({ source, resource }) => {
    const { isHeadOfSubject } = useAzureADGroups();
    const AutocompleteInput = isHeadOfSubject ? RAAutocompleteInput : VeroAutocompleteInput;
    const options = [
        { id: 'validated', name: 'Validated' },
        { id: 'modified', name: 'Modified' },
        { id: 'corrected', name: 'Corrected' }
    ]
    if(resource == "Course"){
        options.push({ id: 'perpetuallyValidated', name: 'Perpetually validated' })
    }

    return (
        <Box display="flex" sx={{ marginTop: '20px', minWidth: '200px'}}>
            <Box flex={4}>
                <AutocompleteInput
                    fullWidth
                    source={source}
                    choices={options}
                    validate={(value, allValues) => validateVersioningType(value, allValues, resource)} />
            </Box>
        </Box>
    );
};